import angular from 'angular';
import { hasOwnProperty, isBlacklistedFilter, isFilterKey } from '../tn.common';
const actions = [];
let timeout = null;

FilterService.isFilterKey = isFilterKey;
FilterService.isBlacklistedFilter = isBlacklistedFilter;

FilterService.$inject = ['$rootScope', '$location', '$timeout'];
export function FilterService($rootScope, $location, $timeout) {
    return function (evName, persist = false) {
        const filters = {};
        const knownFullLengths = Object.create(null);

        function enqueueAction(action) {
            actions.push(action);
            if (!timeout) {
                timeout = $timeout(() => {
                    do {
                        const evalme = actions.shift();
                        evalme();
                    } while (actions.length > 0);
                    timeout = null;
                });
            }
        }

        function clearSearchFilters() {
            if (!persist) {
                return;
            }
            enqueueAction(() => {
                Object.keys($location.search())
                    .filter(isFilterKey)
                    .forEach((key) => $location.search(key, null).replace());
            });
        }

        function pushIntoSearch() {
            if (!persist) {
                return;
            }

            enqueueAction(() => {
                Object.keys(filters).forEach((key) => {
                    if (isBlacklistedFilter(key)) {
                        return;
                    }

                    if (
                        filters[key].length > 0 &&
                        filters[key].length !== knownFullLengths[key]
                    ) {
                        const sortedCopy = filters[key].slice().sort((a, b) => {
                            if (a > b) {
                                return 1;
                            }
                            if (b > a) {
                                return -1;
                            }
                            return 0;
                        });
                        $location.search(`filter_${key}`, sortedCopy.join(','));
                    }
                });
            });
        }

        const self = angular.extend(this, {
            toggle(filter, object, maxLength = -1, updateQueryString = true) {
                if (updateQueryString) {
                    clearSearchFilters();
                }

                // Use the craft base identifier
                const value = object.id;

                //If nothing has been set for this filter then it needs to be initialized
                if (!filters[filter]) {
                    filters[filter] = [];
                }
                const index = filters[filter].indexOf(value);
                if (index === -1) {
                    filters[filter].push(value);
                } else {
                    filters[filter].splice(index, 1);
                    // Remove filter if it's empty, so as to trigger the watches
                    if (filters[filter].length === 0) {
                        delete filters[filter];
                    }
                }
                if (maxLength > -1) {
                    knownFullLengths[filter] = maxLength;
                }
                $rootScope.$broadcast(evName, angular.copy(filters));
                if (updateQueryString) {
                    pushIntoSearch();
                }
            },

            set(filter, value, maxLength = -1, updateQueryString = true) {
                if (updateQueryString) {
                    clearSearchFilters();
                }
                if (value.length) {
                    filters[filter] = value;
                } else {
                    self.reset(filter);
                }
                if (maxLength > -1) {
                    knownFullLengths[filter] = maxLength;
                }
                $rootScope.$broadcast(evName, angular.copy(filters));
                if (updateQueryString) {
                    pushIntoSearch();
                }
            },

            setFilterMaxLength(filter, maxLength) {
                if (maxLength && maxLength > 0) {
                    knownFullLengths[filter] = maxLength;
                }
            },

            reset(filter, notify = false) {
                if (hasOwnProperty(filters, filter)) {
                    delete filters[filter];

                    if (!isBlacklistedFilter(filter)) {
                        clearSearchFilters();
                        pushIntoSearch();
                    }

                    if (notify) {
                        $rootScope.$broadcast(evName, angular.copy(filters));
                    }
                }
            },

            resetAll() {
                clearSearchFilters();
                angular.forEach(filters, (filter, key) => delete filters[key]);
                $rootScope.$broadcast(evName, angular.copy(filters));
                pushIntoSearch();
            },

            get() {
                return filters;
            },

            hasFilter(filterName, filterValue) {
                const hasProp = hasOwnProperty(filters, filterName);
                // if we were given a value to search for, search for it
                if (arguments.length > 1) {
                    return (
                        hasProp && filters[filterName].indexOf(filterValue) > -1
                    );
                }
                return hasProp;
            },

            restoreFromQueryString() {
                if (!persist || !self.hasQueryString()) {
                    return;
                }

                const currentSearch = $location.search();
                Object.keys(currentSearch).forEach((key) => {
                    if (isFilterKey(key) && currentSearch[key]) {
                        const reducedKey = key.replace('filter_', '');
                        self.set(
                            reducedKey,
                            currentSearch[key].split(',').map((val) => {
                                if (parseInt(val).toString() === val) {
                                    return parseInt(val);
                                }
                                if (val === 'true') {
                                    return true;
                                }
                                if (val === 'false') {
                                    return false;
                                }
                                return val;
                            }),
                            -1,
                            false
                        );
                    }
                });
            },

            hasQueryString() {
                return (
                    Object.keys($location.search()).filter(isFilterKey).length >
                    0
                );
            },

            validateFilters(vm, filterMappings) {
                Object.keys(filterMappings).forEach((k) => {
                    const mappedKey = filterMappings[k];
                    if (!mappedKey) {
                        // console.warn(`No mapping for '${k}' found!`);
                        return;
                    }
                    if (!vm[mappedKey]) {
                        // console.warn(`Mapping '${mappedKey}' for '${k}' empty!`);
                        return;
                    }

                    const mappedIds = vm[mappedKey].map((x) => x.id);
                    const filterSet = filters[k];
                    if (filterSet) {
                        self.set(
                            k,
                            angular
                                .copy(filterSet)
                                .filter((i) => mappedIds.indexOf(i) !== -1)
                        );
                    }
                });
            },
        });

        return self;
    };
}
